import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnBulkClip extends SnModel {
  @Expose()
  public notifyByText: boolean;

  @Expose()
  public notifyByEmail: boolean;

  @Expose()
  @Type(() => SnBulkRecordingsCamera)
  public recordings: SnBulkRecordingsCamera[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}

export class SnBulkRecordingsCamera extends SnModel {
  @Expose()
  public cameraId: string;

  @Expose()
  public start: number;

  @Expose()
  public end: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
